import React from 'react';
import OrderCard from './OrderCard';

const FullOrderList = ({ orders, processStatus, isLoading }) => {
     
    return (
        <div>
            <div className="orders-container" style={{
                maxHeight: '60vh',
                overflowY: 'auto',
                marginBottom: '20px'
            }}>
                {orders.map(order => (
                    <OrderCard 
                        key={order.id}
                        order={order}
                        readonly={true}  // Full é apenas visualização
                    />
                ))}
            </div>

            {/* Status de Processamento */}
            {processStatus && (
                <div style={{
                    padding: '10px',
                    margin: '10px 0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '4px',
                    textAlign: 'center',
                    color: processStatus.includes('Erro') ? '#dc3545' : '#0d6efd'
                }}>
                    {processStatus}
                    {isLoading && (
                        <div style={{
                            width: '20px',
                            height: '20px',
                            border: '3px solid #f3f3f3',
                            borderTop: '3px solid #3498db',
                            borderRadius: '50%',
                            margin: '10px auto',
                            animation: 'spin 1s linear infinite'
                        }} />
                    )}
                </div>
            )}
        </div>
    );
};

export default FullOrderList;